const topics = [
  { label: '科幻大片', count: '3.2万', hot: true },
  { label: '国产剧热播', count: '5.8万', hot: true },
  { label: '悬疑推理', count: '2.6万', hot: true },
  { label: '韩剧精选', count: '4.1万', hot: false },
  { label: '治愈系动漫', count: '1.9万', hot: false },
  { label: '动作冒险', count: '3.5万', hot: false },
  { label: '喜剧电影', count: '2.8万', hot: false },
  { label: '纪录纪实', count: '1.2万', hot: false },
  { label: '恐怖惊悚', count: '1.7万', hot: false },
  { label: '漫威宇宙', count: '2.3万', hot: true },
  { label: '高分经典', count: '3.9万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            热门话题
          </h2>
        </div>

        <div className="flex flex-wrap gap-3">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all text-sm whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-500/10 border-primary-500/30 text-primary-500 hover:bg-primary-500 hover:text-background-50'
                  : 'bg-background-100 border-background-200/60 text-foreground-600 hover:border-foreground-400 hover:text-foreground-900'
              }`}
            >
              {topic.hot && <i className="ri-fire-fill text-xs"></i>}
              <span className="font-medium">{topic.label}</span>
              <span className={`text-xs ${topic.hot ? 'opacity-70' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>

        {/* Hot topics highlight */}
        <div className="mt-6 p-4 md:p-5 bg-accent-500/5 border border-accent-500/20 rounded-lg flex items-center gap-3">
          <span className="w-8 h-8 rounded-lg bg-accent-500/15 text-accent-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-line-chart-line"></i>
          </span>
          <p className="text-foreground-600 text-sm">
            <strong className="text-accent-500">趋势上升：</strong>
            科幻大片、国产剧热播、漫威宇宙话题热度持续攀升，悬疑推理类本周搜索量激增 45%
          </p>
        </div>
      </div>
    </section>
  );
}